module.exports = __webpack_public_path__ + "static/media/phone.0ace4536.svg";